
    import { Component } from 'vue-property-decorator';
    import VWidget from '@/components/VWidget.vue';
    import Util from '@/lib/util';
    import url from '@/lib/url'
    import ListBase from '@/lib/listbase';
    import DealerList from './dealer-list.vue';
    import CasisDealerMultiFilter from '../dealer-multi-filter.vue';
    import CasisManufacturerMultiFilter from '../manufacturer-multi-filter.vue';

    class PageFigureRequest {
        year: any = parseInt(new Date().toISOString().substr(0, 4));
        month: any = parseInt(new Date().toISOString().substr(5, 2));
        type: number = null;
        dealer: number = null;
        manufacturer: number = null;
    }
    
    @Component({
        components: { VWidget, DealerList, CasisDealerMultiFilter, CasisManufacturerMultiFilter }
    })

    export default class FigureForm extends ListBase {
        pagerequest: PageFigureRequest = new PageFigureRequest();
        changed: boolean = false;
        listValues: Array<any> = new Array<any>();
        listTickets: Array<any> = new Array<any>();
        totals: Array<any> = new Array<any>();
        showDealers: boolean = false;
        widType: string = 'Actualizados';
        selectedDealerIds: number[] = [];
        selectedManufacturerIds: number[] = [];
        
        /***** computed methods *****/
        get widgets() {
            let sales = this.$store.state.dashboard.figures2;
            let months = this.gCommonList('months');
            return [
                { value: (sales[0] != undefined ? sales[0] : '0'), name: 'Actualizados', icon: 'directions_car', desc: 'Cifras aun no publicadas', onclick: this.openDealer },
                { value: (sales[1] != undefined ? sales[1] : '0'), name: 'Publicados', icon: 'airport_shuttle', desc: 'Cifras Publicadas', onclick: this.openDealer },
                { value: (sales[2] != undefined ? sales[2] : '0'), name: 'Pendientes', icon: 'pending', desc: 'Aun no cargaron sus datos', onclick: this.openDealer },
                { value: (sales[3] != undefined ? sales[3] : 'Fecha'), name: 'Plazo Entrega', icon: 'schedule', desc: months[(this.pagerequest as any).month - 1].name, onclick: null },
            ];
        }

        get loading() {
            return this.$store.state.figure.loading;
        }

        get list() {
            return this.$store.state.figure.list;
        }

        get periods() {
            return this.gCommonList('years');
        }

        get months() {
            let list = this.gCommonList('months');
            list.forEach(m => {
                m['field'] = 'month_' + m.id;
            });
            return list;
        }

        get figureMonths() {
            let list = [];
            this.$store.state.figure.activeList.forEach(m => {
                list[m.month] = m;
            });
            return list;
        }

        get groups() {
            return Util.abp.list.getList('G_FIGURE');
        }

        get groupsTicket() {
            return [
                { "id": 1, "name": "TICKETS FACTURACION" },
                { "id": 2, "name": "TICKETS MANO DE OBRA" },
                { "id": 3, "name": "TICKETS TOTAL" }
            ];
        }

        get manufacturers() {
            return this.$store.state.manufacturer.activeList;
        }

        get dealer() {
            const selectedDealer = Number(this.$store.state.app.dealer);
            if (selectedDealer > 0) return selectedDealer;

            const sessionDealer = Number(Util.abp.session.dealerId);
            return this.isDealer && sessionDealer > 0 ? sessionDealer : selectedDealer;
        }
               
        get manufacturer() {
            return this.$store.state.app.manufacturer;
        }

        get figure() {
            if (this.list[0] == undefined) return null;
            if (this.list[0].figure_id == null) return null;
            return {
                id: this.list[0].figure_id,
                month: this.list[0].figure_month,
                state: this.list[0].figure_state,
                published: this.list[0].figure_published,
            };
        }

        get lastMonth() {
            if (this.figure == null) return this.months[0];

            return this.months[this.figure.month - 1];
        }

        get nextMonth() {
            if (this.figure == null) return this.months[0];

            let month = this.figure.month - 1;
            if (this.figure.published && month <= 10) month++;
            return this.months[month];
        }

        get state() {
            if (this.figure == null) return Util.abp.list.get('E_FIGURE','DI');
            return Util.abp.list.getItem(this.figure.state);
        }

        get checking() {
            return this.$store.state.dashboard.loading;
        }

        get isAdmin() {
            return Util.abp.session.isAdmin;
        }

        get statePU() {
            return Util.abp.list.get('E_FIGURE', 'PU').id;
        }

        get isDealer() {
            return Util.abp.session.isDealer();
        }

        get isImporter() {
            const user = this.$store.state.session.user;
            return !!(user && user.roles && user.roles.some((role: any) => role.name === 'importer'));
        }

        get canLoadCasisSima() {
            return this.isAdmin || this.isImporter;
        }

        get currentDealer() {
            return this.$store.state.dealer.activeList.find((item: any) => Number(item.id) === Number(this.dealer));
        }

        get isInternalSimaDealer() {
            return !!(this.currentDealer && [15, 30].includes(Number(this.currentDealer.code)));
        }

        get canEditFigures() {
            if (this.isAdmin || this.isImporter) return true;
            return this.isDealer && !!this.currentDealer && !this.isInternalSimaDealer;
        }

        get isSingleScope() {
            return this.selectedDealerIds.length === 1 && this.selectedManufacturerIds.length === 1;
        }

        /***** fields events *****/
        columns(group: string) {
            let cols = [{ value: 'concept_name', text: group.toUpperCase(), type: 'text', sortable: false, align: 'start', width: '280px', class: '' }];

            this.months.forEach(m => {
                let cClass = (this.figure != null && m.field == ('month_' + this.figure.month) ? 'selected-month' : '');
                if (this.figure != null && this.figure.published && this.figure.month == 12) cClass = '';
                cols.push({ value: m.field, text: m.name, type: 'text', width: '82px', sortable: false, align: 'center', class: cClass });
            });
            cols.push({ value: 'total', text: 'TOTAL', type: 'text', width: '65px', sortable: false, align: 'center', class: '' });
            return cols;
        }

        
        setList() {
            this.listValues = [];
            this.listTickets = [];            
            this.groups.forEach(gru => {
                this.listValues[gru.id] = [];

                this.list.forEach(item => {
                    if (item.group_id == gru.id)
                        this.listValues[gru.id].push(item);
                });
            });

            let listTA = this.listValues[Util.abp.list.get('G_FIGURE', 'TA').id];
            let listVE = this.listValues[Util.abp.list.get('G_FIGURE', 'VE').id];
            let listMO = this.listValues[Util.abp.list.get('G_FIGURE', 'IN').id];
            let concepts = ['Mantenimiento', 'Reparacion Mecanica', 'Planchado y Pintura', 'Garantias', 'Ordenes Interna']

            this.groupsTicket.forEach(gru => {
                this.listTickets[gru.id] = [];
                if (gru.id == 1) {
                    concepts.forEach((concept, k) => {
                        let item = { concept_name: concept, number: k+1, total:0 };
                        this.months.forEach(m => {
                            if (listVE[k][m.field] != null && listTA[k][m.field] != null && listTA[k][m.field] > 0 && k < 3)
                                item[m.field] = listVE[k][m.field] / listTA[k][m.field];
                        });

                        if (listTA[k].total > 0 && k < 3) item.total = listVE[k].total / listTA[k].total;

                        this.listTickets[gru.id].push(item);
                    })
                    
                } else if (gru.id == 2) {
                    concepts.forEach((concept, k) => {
                        let item = { concept_name: concept, number: k + 1, total: 0 };
                        this.months.forEach(m => {
                            let totalMO = listMO[k][m.field];
                            if (k == 2) totalMO = listMO[2][m.field] + listMO[3][m.field];
                            if (k == 3) totalMO = listMO[4][m.field];
                            if (k == 4) totalMO = listMO[6][m.field];
                            if (totalMO != null && listTA[k][m.field] != null && listTA[k][m.field] > 0)
                                item[m.field] = totalMO / listTA[k][m.field];
                        });

                        let total = listMO[k].total;
                        if (k == 2) total = listMO[2].total + listMO[3].total;
                        if (k == 3) total = listMO[4].total;
                        if (k == 4) total = listMO[6].total;

                        if (listTA[k].total > 0) item.total = total / listTA[k].total;

                        this.listTickets[gru.id].push(item);
                    })
                } else if (gru.id == 3) {
                    concepts.forEach((concept, k) => {
                        let item = { concept_name: concept, number: k + 1, total: 0 };
                        this.months.forEach(m => {
                            let totalMO = listMO[k][m.field];
                            if (k == 2) totalMO = listMO[2][m.field] + listMO[3][m.field];
                            if (k == 3) totalMO = listMO[4][m.field];
                            if (k == 4) totalMO = listMO[6][m.field];

                            let total = (listVE[k][m.field] != null ? listVE[k][m.field] : 0) + (totalMO != null ? totalMO : 0);
                            if (listTA[k][m.field] > 0)
                                item[m.field] = total / listTA[k][m.field];
                        });

                        let total = listMO[k].total;
                        if (k == 2) total = listMO[2].total + listMO[3].total;
                        if (k == 3) total = listMO[4].total;
                        if (k == 4) total = listMO[6].total;

                        let total2 = listVE[k].total + total;
                        if (listTA[k].total > 0) item.total = total2 / listTA[k].total;

                        this.listTickets[gru.id].push(item);
                    })
                }
            });
        }

        imageSrc(image) {
            return url + image;
        }

        updateTotal(item) {
            this.changed = true;
            item.total = 0;
            this.months.forEach(m => {
                item.total += (item[m.field] == null || item[m.field] == '' ? 0 : parseFloat(item[m.field]));
            });
            this.setTotals();
        }

        setTotals() {
            let groupTA = Util.abp.list.get('G_FIGURE', 'TA').id;
            let groupHO = Util.abp.list.get('G_FIGURE', 'HO').id;
            this.totals = [];
            this.groups.forEach(gru => {
                this.totals[gru.id] = {total: 0};

                this.months.forEach(m => {
                    this.totals[gru.id][m.field] = 0;
                });

                if (this.listValues[gru.id] != undefined) {
                    this.listValues[gru.id].forEach(item => {
                        this.months.forEach(m => {
                            if (item.number != null && ((item.group_id == groupTA && item.number < 5) || (item.group_id == groupHO && item.number != 27) || (item.group_id != groupTA && item.group_id != groupHO)))
                                this.totals[gru.id][m.field] += parseFloat((item[m.field] != undefined && item[m.field] != '' ? item[m.field] : 0));
                        });
                    });

                    this.months.forEach(m => {
                        this.totals[gru.id][m.field] = parseFloat(this.totals[gru.id][m.field].toFixed(2));
                        this.totals[gru.id].total += this.totals[gru.id][m.field];
                    });
                }

                this.totals[gru.id].total = parseFloat(this.totals[gru.id].total.toFixed(2));
            });
        }

        getInitials(string) {
            return Util.getInitials(string);
        }

        onFocus(e) {
            e.target.select();
        }

        changeType(id) {
            this.pagerequest.type = id;
            this.selectedManufacturerIds = [id];
            this.$store.commit('app/setManufacturer', id);
            this.loadData();
        }

        changeManufacturers() {
            const ids = this.selectedManufacturerIds || [];
            this.pagerequest.type = ids.length === 0 ? null : (ids.length === 1 ? ids[0] : 0);
            this.$store.commit('app/setManufacturer', ids.length === 1 ? ids[0] : 0);
            if (ids.length === 0) {
                this.$store.commit('figure/clearData');
                this.listValues = [];
                this.listTickets = [];
                this.totals = [];
                this.loadWidgets();
            } else {
                this.loadData();
            }
        }

        changeDealers() {
            const ids = this.selectedDealerIds || [];
            this.$store.commit('app/setDealer', ids.length === 1 ? ids[0] : 0);
            if (ids.length === 0) {
                this.$store.commit('figure/clearData');
                this.listValues = [];
                this.listTickets = [];
                this.totals = [];
            } else {
                this.loadData();
            }
        }

        openDealer(item) {
            this.widType = item.name;
            this.showDealers = true;
        }

        async exportData() {
            this.applyRequestFilters();
            let filename = await this.$store.dispatch({
                type: 'figure/export',
                data: this.pagerequest
            });
            if (filename != '' && filename != undefined)
                window.location = filename;
        }

        async create() {
            
            await this.$store.dispatch({
                type: 'figure/create',
                data: {
                    dealer_id: this.dealer,
                    manufacturer_id: this.manufacturer,
                    vehicle_type_id: this.pagerequest.type,
                    year: this.pagerequest.year,
                    month: this.nextMonth.id
                }
            });
            await this.loadData();
        }

        async save(publish = false) {
            if (this.figure != null) {
                let model = Util.extend(true, {}, this.figure);
                model.concepts = [];

                if (publish)
                    model.state = Util.abp.list.get('E_FIGURE', 'PU').id;

                this.list.forEach(item => {
                    model.concepts.push({
                        figure_id: item.figure_id,
                        concept_id: item.concept_id,
                        year: item.year,
                        month: item.figure_month,
                        amount: item['month_' + item.figure_month],
                    });
                });

                await this.$store.dispatch({
                    type: 'figure/update',
                    data: model
                });
                await this.loadData();
            }
        }

        async saveAmount(item) {
            if (item != null) {
                item.vehicle_type_id = this.pagerequest.type;
                item.dealer_id = this.dealer;
                item.manufacturer_id = this.manufacturer;
                await this.$store.dispatch({
                    type: 'figure/updateConcept',
                    data: item
                });
            }
        }

        async loadData() {
            if (this.selectedDealerIds.length === 0 || this.selectedManufacturerIds.length === 0) {
                this.$store.commit('figure/clearData');
                this.listValues = [];
                this.listTickets = [];
                this.totals = [];
                return;
            }
            this.applyRequestFilters();
            await this.$store.dispatch({
                type: 'figure/getAll',
                data: this.pagerequest
            });
            this.setList();
            this.setTotals();
            this.loadWidgets();
        }

        applyRequestFilters() {
            const dealerIds = this.selectedDealerIds.length > 0
                ? [...this.selectedDealerIds]
                : (this.dealer > 0 ? [this.dealer] : []);

            (this.pagerequest as any).dealer_ids = dealerIds;
            this.pagerequest.dealer = dealerIds.length === 1 ? dealerIds[0] : null;
            (this.pagerequest as any).manufacturer_ids = [...this.selectedManufacturerIds];
            this.pagerequest.manufacturer = this.selectedManufacturerIds.length === 1
                ? this.selectedManufacturerIds[0]
                : null;
        }

        async loadWidgets() {
            if (!this.isDealer)
                await this.$store.dispatch({
                    type: 'dashboard/getWidgetFigures',
                    data: this.pagerequest
                });
        }

        async enableFigure(item) {
            await this.$store.dispatch({
                type: 'figure/enable',
                data: {
                    id: item.id,
                    dealer: this.dealer,
                    manufacturer: this.manufacturer,
                    year: this.pagerequest.year,
                    month: item.month,
                }
            });

            await this.loadData();
        }

        async confirmFigure(item) {
            await this.$store.dispatch({
                type: 'figure/confirm',
                data: {
                    id: item.id,
                    dealer: this.dealer,
                    manufacturer: this.manufacturer,
                    year: this.pagerequest.year,
                    month: item.month,
                }
            });
            await this.loadData();
        }
               
        async processApiCasis() {
            await this.$store.dispatch({
                type: 'figure/processApiCasis',
                data: { year: this.pagerequest.year, month: this.pagerequest.month}
            });
            await this.loadData();
        }

        async mounted() {
            if (!this.$store.state.manufacturer.activeList.length)
                await this.$store.dispatch({ type: 'manufacturer/getAllActive' });
            if (!this.$store.state.dealer.activeList.length)
                await this.$store.dispatch({ type: 'dealer/getAllActive' });

            if (this.isDealer && Number(Util.abp.session.dealerId) > 0) {
                this.$store.commit('app/setDealer', Number(Util.abp.session.dealerId));
                this.selectedDealerIds = [Number(Util.abp.session.dealerId)];
            } else if (this.selectedDealerIds.length === 0 && this.dealer > 0) {
                this.selectedDealerIds = [this.dealer];
            }
            if (!this.isDealer && this.selectedDealerIds.length === 0) {
                this.selectedDealerIds = this.$store.state.dealer.activeList.map((item: any) => item.id);
                this.$store.commit('app/setDealer', this.selectedDealerIds.length === 1 ? this.selectedDealerIds[0] : 0);
            }
            if (this.pagerequest.type != null)
                await this.loadData();
            await this.loadWidgets();
        }

        async created() {
        }
    }
